import React from 'react'
import { Outlet } from 'react-router-dom'
import { Header } from './Header'
import { JourneyProgress } from './JourneyProgress'
import { useJourneyStore } from '@/stores/journeyStore'

export function MainLayout() {
  const { user, currentStage, stages } = useJourneyStore()
  
  const currentStageData = stages.find(stage => stage.id === currentStage)
  const completedStages = stages.filter(stage => stage.isCompleted).length
  const totalStages = stages.length
  const overallProgress = Math.round((completedStages / totalStages) * 100)

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-indigo-50 dark:from-gray-900 dark:via-gray-800 dark:to-indigo-900">
      <Header />
      
      <main className="container mx-auto px-4 py-8">
        <div className="animate-fade-in">
          <Outlet />
        </div>
      </main>
    </div>
  )
}